export default theme => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
    },
    tourCard: {
        marginBottom: theme.spacing(2),
        borderRadius: 12,
        overflow: 'hidden',
        position: 'relative',
    },
    cardActionArea: {
        width: '100%',
        display: 'block',
        textAlign: 'left',
    },
    cardContent: {
        padding: theme.spacing(2),
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(1),
    },
    vehicleWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    vehicleIcon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1),
        fontSize: 20,
    },
    vehicleText: {
        fontWeight: 'bold',
        lineHeight: 1.2,
    },
    statusChip: {
        fontWeight: 600,
        height: 24,
        backgroundColor: '#fff3e0'
    },
    statusIcon: {
        fontSize: 16,
        marginRight: 4,
    },
    tourInfoBox: {
        marginBottom: theme.spacing(2),
    },
    tourLabel: {
        fontWeight: 500,
    },
    footerBox: {
        marginTop: theme.spacing(2),
    },
    metaDataBox: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.secondary,
    },
    smallIcon: {
        fontSize: 16,
        marginRight: 4,
    },
    captionText: {
        fontSize: '0.8rem',
    },
    noToursBox: {
        textAlign: 'center',
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
    },
    paper: {
        backgroundColor: '#e3f2fd',
        color: '#0d47a1',
        padding: '12px 16px',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '8px'
    }
});